import React from 'react';
import { UnstyledButton } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown, faPause, faScroll, faCircleCheck, faUtensils, faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { OrdersFilterKey } from './orders-filter.utils';
import classes from './orders-filter.module.scss';

const ALL_LABEL = 'הכל';
const WAITING_LABEL = 'בהמתנה';
const BILL_LABEL = 'חשבון';
const APPROVALS_LABEL = 'אישורים';
const PREPARING_LABEL = 'בהכנה';
const ORDERS_FILTER_ARIA = 'סינון הזמנות';

const CARDS: { key: OrdersFilterKey; label: string; icon: IconProp }[] = [
  { key: 'all', label: ALL_LABEL, icon: faLayerGroup as IconProp },
  { key: 'waiting', label: WAITING_LABEL, icon: faPause as IconProp },
  { key: 'bill', label: BILL_LABEL, icon: faScroll as IconProp },
  { key: 'vip', label: 'VIP', icon: faCrown as IconProp },
  { key: 'approvals', label: APPROVALS_LABEL, icon: faCircleCheck as IconProp },
  { key: 'preparing', label: PREPARING_LABEL, icon: faUtensils as IconProp },
];

export type OrdersFilterCardsProps = {
  active: OrdersFilterKey;
  counts: Record<OrdersFilterKey, number>;
  onSelect: (key: OrdersFilterKey) => void;
};

const OrdersFilterCardsComponent: React.FC<OrdersFilterCardsProps> = ({ active, counts, onSelect }) => (
  <div className={classes.row} role="group" aria-label={ORDERS_FILTER_ARIA} dir="rtl">
    {CARDS.map((card) => (
      <UnstyledButton
        key={card.key}
        component="button"
        type="button"
        aria-pressed={active === card.key}
        data-testid={`orders-filter-${card.key}`}
        className={`${classes.card} ${active === card.key ? classes.cardActive : ''}`}
        onClick={() => onSelect(card.key)}
      >
        <span className={classes.cardTop}>
          <span className={classes.count}>{counts[card.key]}</span>
          <FontAwesomeIcon icon={card.icon} className={classes.icon} />
        </span>
        <span className={classes.label}>{card.label}</span>
      </UnstyledButton>
    ))}
  </div>
);

export const OrdersFilterCards = React.memo(OrdersFilterCardsComponent);